module.exports = __webpack_public_path__ + "img/analytics.c7882e54.svg";